import { render, staticRenderFns } from "./SoftwareSection.vue?vue&type=template&id=7d1f9637&scoped=true&"
import script from "./SoftwareSection.vue?vue&type=script&lang=js&"
export * from "./SoftwareSection.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareSection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SoftwareSection.vue?vue&type=style&index=1&id=7d1f9637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f9637",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDivider,VImg,VRow})
